import React from 'react';
import Avatar from './Avatar.jsx';

import './AvatarContainer.css';

function AvatarContainer({ image, button, right, children }) {

    return (
        <div className="avatar-container">
            <div className="left">
                <Avatar image={image}>
                    { button }
                </Avatar>
            </div>
            <div className="right">
                { right }
                { React.Children.count(children) > 0 ? (
                    <div className="children">
                        { children }
                    </div>
                ) : null }
            </div>
        </div>
    );
}

export default AvatarContainer;


// WEBPACK FOOTER //
// ./src/components/AvatarContainer.jsx